// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('users', {
    parent: 'main',
    url: '/users',
    views: {
      'main-content': {
        controller: 'MainUsersController as vm',
        templateUrl: 'main/users/users.tpl.html',
      },
    },
    data: { pageTitle: 'Users' },
  });

  $stateProvider.state('users.detail', {
    url: '/:userId',
    views: {
      'main-content@main': {
        controller: 'UserDetailsController as vm',
        template: '<user-details user-id="vm.userId"></user-details>',
      },
    },
    data: { pageTitle: 'User details' },
  });
};

class MainUsersController {
  constructor() {
    'ngInject';
  }
}

class UserDetailsController {
  constructor($stateParams) {
    'ngInject';
    this.userId = Number($stateParams.userId);
  }
}

angular
  .module('main.users', [])
  .config(config)
  .controller('MainUsersController', MainUsersController)
  .controller('UserDetailsController', UserDetailsController);
